import Vue from 'vue'
import router from '@/product/router'
import store from '@/product/store'

import './main.entry.css'

const init = () => {
  new Vue({
    store,
    router,
    el: '#js-product-app',
    template: '<router-view></router-view>'
  })
}

init()
